"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigApp = void 0;
const App_1 = require("../classes/App");
const ConfigApp = () => {
    App_1.App.API_URL = "https://profimoll.ru";
    //App.API_URL = "https://pmtest.solarit.ru";
    //App.API_URL = "http://127.0.0.1:6001";
    App_1.App.API_PATH = "/api";
    // App.API_PATH = "/api/";
};
exports.ConfigApp = ConfigApp;
// AppYB.EVENTS_URL = "https://office.test.yes-boss.ae";
// AppYB.FILES_PATH = AppYB.API_URL+AppYB.API_PATH+"files?fileId=";
// AppYB.API_URL = "https://office.yes-boss.ae";
// AppYB.API_PATH = "/api/admin/";
// AppYB.EVENTS_URL = "https://office.yes-boss.ae";
// AppYB.FILES_PATH = AppYB.API_URL+AppYB.API_PATH+"files?fileId="; 
//# sourceMappingURL=config.js.map